import { useEffect, useRef } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function getSessionId() {
  let sid = Cookies.get("gmp_sid");
  if (!sid) {
    sid = crypto.randomUUID();
    Cookies.set("gmp_sid", sid, { expires: 1, sameSite: "lax" }); // 24hr session
  }
  return sid;
}

function getUtmParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source") || undefined,
    utm_medium: params.get("utm_medium") || undefined,
    utm_campaign: params.get("utm_campaign") || undefined,
  };
}

/**
 * Fires a page view event on mount and whenever `path` changes.
 * Skips admin routes.
 */
export function usePageView(path) {
  const lastPath = useRef(null);

  useEffect(() => {
    if (!path || path === lastPath.current) return;
    if (path.startsWith("/admin")) {
      lastPath.current = path;
      return;
    }
    lastPath.current = path;

    const payload = {
      path,
      referrer: document.referrer || undefined,
      session_id: getSessionId(),
      screen: `${window.innerWidth}x${window.innerHeight}`,
      ...getUtmParams(),
    };

    axios
      .post(`${API}/analytics/pageview`, payload, { withCredentials: false })
      .catch(() => {
        /* silently ignore tracking failures */
      });
  }, [path]);
}
